/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
import {
  FontWeight, ImageProps, Typography,
} from '@doveit/lego';
import Image from 'next/image';
import React from 'react';
import { goToPage, URLObject } from '../../utils/links';
import * as styles from './QuickAction.style';

export interface QuickActionProps {
  action: string,
  locality: string,
  image: ImageProps,
  urlObject?: URLObject,
}

const QuickAction: React.FC<QuickActionProps> = ({
  action,
  locality,
  image,
  urlObject,
}) => {
  const onClick = React.useCallback(() => {
    if (urlObject) {
      goToPage(urlObject);
    }
  }, [urlObject]);

  return (
    <div
      data-ref="quick-action"
      css={styles.base}
      onClick={urlObject && onClick}
    >
      <div css={styles.info}>
        <Typography.H4 fontWeight={FontWeight.NORMAL}>
          <strong>{action}</strong> a {locality}
        </Typography.H4>
      </div>
      <div css={styles.image}>
        <Image
          src={image.src}
          alt={image.alt}
          width="64"
          height="60"
        />
      </div>
    </div>
  );
};

export default QuickAction;
